import { render, staticRenderFns } from "./DragAndDropImageUploaderModal.vue?vue&type=template&id=22b3a530&scoped=true&"
import script from "./DragAndDropImageUploaderModal.vue?vue&type=script&lang=js&"
export * from "./DragAndDropImageUploaderModal.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropImageUploaderModal.vue?vue&type=style&index=0&id=22b3a530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3a530",
  null
  
)

export default component.exports